import React, { useState,useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { setYearList,setMonthList,setDateRange,dynamicUrl,formatDate } from './Function';
import { useDynamicLink } from './DynamicUse';
import { Row,Col,Card,Table,Button,Placeholder,Form,InputGroup,Spinner } from 'react-bootstrap';
import { NavLink } from 'react-router-dom';
const NoticesAll = () => 
{
    const appLanguage = localStorage.getItem('appLanguage') || 'en';
    const { t } = useTranslation();
    const dynamicLinkData = useDynamicLink(350);
    const[isLoading, setLoading] = useState(true);
    const[isLoadMore, setLoadMore] = useState(true);
    const[Rows, setRows] = useState(0);
    const[Notices,setNotices]=useState([]);
    const[keyword, setKeyword] = useState('');
    const[year, setYear] = useState(0);
    const[month, setMonth] = useState(0);
    const KeywordChange = (e) => setKeyword(e.target.value.trim() || '');
    const YearChange = (e) => setYear(Number(e.target.value) || 0);
    const MonthChange = (e) => setMonth(Number(e.target.value) || 0);
    useEffect(()=>
    {
        fetchNotices(true);
        // eslint-disable-next-line
    },[])
    const fetchNotices = async (isReset) =>
    {
        if (isReset === true) 
        {
            setRows(0);
            setNotices([]);
        }
        try 
        {
            setLoading(true);
            var ntId = 0;
            var keywordText = keyword || 'none';
            const currentRows = isReset ? 0 : Rows;
            const { startDate, endDate } = setDateRange(year, month, 0, 0, 1);
            const callApi = global.config.API_URL + `notices/list/${ntId}/${keywordText}/${startDate}/${endDate}/${currentRows}`;
            if(global.config.IsPrint) console.info('fetchNotices : API', callApi);
            const response = await fetch(callApi);
            const result = await response.json();
            if (result.length > 0) 
            {
                setNotices(prevResults => Rows === 0 ? result : [...prevResults, ...result]);
                setRows(currentRows + 30);             
                setLoadMore(true);
            } 
            else 
            {
                setLoadMore(false);
            }
            if( global.config.IsPrint === true ) { console.info('fetchNotices : Result',result); }
        }
        catch (error) 
        { 
            console.error('fetchNotices : Error', error.message);            
        }
        finally
        {
            setLoading(false);
        }
    };
    const handleSubmit = (e) => 
    {
        if (e)
        {
            e.preventDefault();
            if (!keyword && year === 0 && month === 0) 
            {
                alert(t('FilterAlert'));
                return;
            }
        }
        fetchNotices(true);
    }
    return (
        <Card className=' mb-4'>
            <Card.Header className='text-center fs-3 text-uppercase'>
                {t('Notices')}
            </Card.Header>
            <Card.Body>
                <Card className=' mb-3'>
                    <Card.Body>
                        <Form onSubmit={handleSubmit}>
                            <div className='mb-2 fw-bold'>{t('FilterSearch')}</div>
                            <Row className='g-2'>
                                <Col md={6} data-aos="fade-right" data-aos-duration="1000">
                                    <Form.Control type="text" placeholder={t('FilterPlaceholder')} onChange={KeywordChange} value={keyword} />
                                </Col>
                                <Col md={6} data-aos="fade-right" data-aos-duration="1000">
                                    <InputGroup>
                                        <Form.Select onChange={YearChange} value={year}>
                                            <option value={0}>{t('FilterYear')}</option>
                                            {setYearList(0, 0).map((year) => (
                                                <option key={year} value={year}>
                                                    {year}
                                                </option>
                                            ))}
                                        </Form.Select>
                                        <Form.Select onChange={MonthChange} value={month}>
                                            <option value={0}>{t('FilterMonth')}</option>
                                            {setMonthList().map(({ value, label }) => (
                                                <option key={value} value={value}>
                                                    {label}
                                                </option>
                                            ))}
                                        </Form.Select>
                                        <Button type="submit" className='btn btn-info'><i className="bi bi-search"></i> {t('FilterSearch')}</Button>
                                    </InputGroup>                                    
                                </Col>
                            </Row>
                        </Form>
                    </Card.Body>
                </Card>
                <Table responsive bordered className='rounded-top text-center overflow-hidden mb-0'>
                <thead>
                    <tr>
                        <th className='w-50'>{t('Title')}</th>
                        <th>{t('Type')}</th>
                        <th>{t('UploadDate')}</th>
                        <th>{t('Download')}</th>
                    </tr>
                </thead>
                {isLoading ? (
                <tbody>
                {[...Array(10)].map((_,index)=>(
                    <tr key={index}>
                        <th className="table-success"><Placeholder xs={10} /></th>
                        <th className="text-center"><Placeholder xs={10} /></th>
                        <td className="text-center"><Placeholder xs={10} /></td>
                        <td className="text-center">
                            <Button className="btn btn-light w-75"><Placeholder xs={12} /></Button>
                        </td>                            
                    </tr>
                ))}
                </tbody>
                ) : (
                <React.Fragment>
                {Notices.length > 0 ? (                
                <tbody>
                {Notices.map((sn,index)=>(
                    <tr key={index}>                            
                        <th className="table-success" dangerouslySetInnerHTML={{__html: appLanguage === 'hi' ? (sn.sn_display_en === "1" ? sn.sn_name_hi || '' : sn.sn_name_hi || sn.sn_name) : sn.sn_name}}></th>
                        <th className="text-center">{appLanguage === 'hi' ? ( sn.noticeType.nt_name_hi ? sn.noticeType.nt_name_hi : sn.noticeType.nt_name ) : sn.noticeType.nt_name}</th>
                        <td className="text-center">{formatDate(sn.sn_date)}</td>
                        <td className="text-center">
                            <NavLink to={appLanguage === 'hi' ? `/नोटिस/विवरण/${sn.sn_htaccess_hi || sn.sn_htaccess}` : `/notice/details/${sn.sn_htaccess}`} className="btn btn-light" target='_blank' rel="noopener noreferrer">
                                {t('ViewDownload')}
                            </NavLink>
                        </td>
                    </tr>
                ))}
                </tbody>
                ) : (
                <tbody>
                    <tr>
                        <td colSpan={4} className='text-center'>{t('NoResult')}</td>
                    </tr>
                </tbody>
                )}
                </React.Fragment>                
                )}
                </Table>
            </Card.Body>
            <Card.Footer className='d-flex justify-content-between bg-white'>
                {dynamicLinkData && dynamicLinkData.map((sp,index)=>(
                    <NavLink key={index} to={dynamicUrl(sp)} className='btn btn-info'>
                        {t('Archives')}
                    </NavLink>
                ))} 
                {isLoadMore &&
                <Button variant='info' onClick={() => fetchNotices(false)} disabled={isLoading}>
                    {isLoading ? (
                    <React.Fragment>
                        <Spinner animation="grow" variant="light" size="sm" />
                        <Spinner animation="grow" variant="danger" size="sm" />
                        <span className='ms-2'>{t('PleaseWait')}</span>
                    </React.Fragment>
                    ) : t('LoadMore')}
                </Button>}                
            </Card.Footer>
        </Card>
    );
}
export default NoticesAll;